module.exports = __webpack_public_path__ + "static/media/icons8-discord.b39c2aa4.svg";